// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-date-picker-header {
  align-items: flex-end;
  height: 70px;
  display: grid;
  grid-template-areas: "prepend content append";
  grid-template-columns: min-content minmax(0, 1fr) min-content;
  overflow: hidden;
  padding-inline: 24px 12px;
  padding-bottom: 12px;
}

:where(.vuetify-styles) .v-date-picker-header__append {
  grid-area: append;
}

:where(.vuetify-styles) .v-date-picker-header__prepend {
  grid-area: prepend;
  padding-inline-start: 8px;
}

:where(.vuetify-styles) .v-date-picker-header__content {
  align-items: center;
  display: inline-flex;
  font-size: 32px;
  line-height: 40px;
  grid-area: content;
  justify-content: space-between;
  white-space: pre-wrap;
}
:where(.vuetify-styles) .v-date-picker-header--clickable .v-date-picker-header__content {
  cursor: pointer;
}
:where(.vuetify-styles) .v-date-picker-header--clickable .v-date-picker-header__content:not(:hover) {
  opacity: 0.7;
}

:where(.vuetify-styles) .date-picker-header-transition-enter-active,
:where(.vuetify-styles) .date-picker-header-reverse-transition-enter-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .date-picker-header-transition-leave-active,
:where(.vuetify-styles) .date-picker-header-reverse-transition-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

:where(.vuetify-styles) .date-picker-header-transition-enter-from {
  transform: translate(0, 100%);
}
:where(.vuetify-styles) .date-picker-header-transition-leave-to {
  opacity: 0;
  transform: translate(0, -100%);
}

:where(.vuetify-styles) .date-picker-header-reverse-transition-enter-from {
  transform: translate(0, -100%);
}
:where(.vuetify-styles) .date-picker-header-reverse-transition-leave-to {
  opacity: 0;
  transform: translate(0, 100%);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VDatePicker/VDatePickerHeader.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,6CAA6C;EAC7C,6DAA6D;EAC7D,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;;EAEE,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,6BAA6B;AAC/B","sourcesContent":[".v-date-picker-header {\n  align-items: flex-end;\n  height: 70px;\n  display: grid;\n  grid-template-areas: \"prepend content append\";\n  grid-template-columns: min-content minmax(0, 1fr) min-content;\n  overflow: hidden;\n  padding-inline: 24px 12px;\n  padding-bottom: 12px;\n}\n\n.v-date-picker-header__append {\n  grid-area: append;\n}\n\n.v-date-picker-header__prepend {\n  grid-area: prepend;\n  padding-inline-start: 8px;\n}\n\n.v-date-picker-header__content {\n  align-items: center;\n  display: inline-flex;\n  font-size: 32px;\n  line-height: 40px;\n  grid-area: content;\n  justify-content: space-between;\n  white-space: pre-wrap;\n}\n.v-date-picker-header--clickable .v-date-picker-header__content {\n  cursor: pointer;\n}\n.v-date-picker-header--clickable .v-date-picker-header__content:not(:hover) {\n  opacity: 0.7;\n}\n\n.date-picker-header-transition-enter-active,\n.date-picker-header-reverse-transition-enter-active {\n  transition-duration: 0.3s;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.date-picker-header-transition-leave-active,\n.date-picker-header-reverse-transition-leave-active {\n  transition-duration: 0.3s;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.date-picker-header-transition-enter-from {\n  transform: translate(0, 100%);\n}\n.date-picker-header-transition-leave-to {\n  opacity: 0;\n  transform: translate(0, -100%);\n}\n\n.date-picker-header-reverse-transition-enter-from {\n  transform: translate(0, -100%);\n}\n.date-picker-header-reverse-transition-leave-to {\n  opacity: 0;\n  transform: translate(0, 100%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
